// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calendarGridDay {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: white;
}

.calendarGridDay_header {
    padding: 16px 0;
    border-bottom: 1px solid #e0e0e0;
}

.calendarGridDay_date {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.calendarGridDay_container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-top: 15px;
}

.calendarGridDay_scroll_container {
    flex: 1;
    overflow-y: auto;
    width: 100%;
}

.calendarGridDay_body {
    width: 100%;
}

.calendarGridDay_time_row {
    display: grid;
    grid-template-columns: 80px 1fr;
    min-height: 60px;
    border-bottom: 1px solid #e0e0e0;
}

.calendarGridDay_time_row:last-child {
    border-bottom: none;
}

.calendarGridDay_time_slot {
    padding: 8px;
    border-right: 1px solid #e0e0e0;
    background: #f8f9fa;
    font-size: 12px;
    color: #666;
    text-align: center;
    font-weight: 500;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 8px;
}

.calendarGridDay_cell {
    border-right: 1px solid #e0e0e0;
    position: relative;
    cursor: pointer;
    background: white;
}

.calendarGridDay_cell:hover {
    background: #f8f9fa;
}

.calendarGridDay_ticket {
    position: absolute;
    left: 2px;
    right: 2px;
    background: var(--ticket-color-back);
    border-left: 3px solid var(--ticket-color-side);
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    overflow: hidden;
    z-index: 5;
    min-height: 40px;
}

.calendarGridDay_ticket:hover {
    transform: scale(1.02);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.calendarGridDay_ticket--colorA {
    --ticket-color-back: #e3f2fd;
    --ticket-color-side: #2196f3;
    --ticket-color: #1976d2;
}

.calendarGridDay_ticket--colorB {
    --ticket-color-back: #f3e5f5;
    --ticket-color-side: #9c27b0;
    --ticket-color: #7b1fa2;
}

.calendarGridDay_ticket--colorC {
    --ticket-color-back: #e8f5e8;
    --ticket-color-side: #4caf50;
    --ticket-color: #388e3c;
}

.calendarGridDay_ticket_content {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.calendarGridDay_ticket_time {
    font-size: 10px;
    color: var(--ticket-color);
    font-weight: 500;
}

.calendarGridDay_ticket_title {
    font-size: 12px;
    color: var(--ticket-color);
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarGridDay.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":["\n.calendarGridDay {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background: white;\n}\n\n.calendarGridDay_header {\n    padding: 16px 0;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.calendarGridDay_date {\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n}\n\n.calendarGridDay_container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    margin-top: 15px;\n}\n\n.calendarGridDay_scroll_container {\n    flex: 1;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.calendarGridDay_body {\n    width: 100%;\n}\n\n.calendarGridDay_time_row {\n    display: grid;\n    grid-template-columns: 80px 1fr;\n    min-height: 60px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.calendarGridDay_time_row:last-child {\n    border-bottom: none;\n}\n\n.calendarGridDay_time_slot {\n    padding: 8px;\n    border-right: 1px solid #e0e0e0;\n    background: #f8f9fa;\n    font-size: 12px;\n    color: #666;\n    text-align: center;\n    font-weight: 500;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding-top: 8px;\n}\n\n.calendarGridDay_cell {\n    border-right: 1px solid #e0e0e0;\n    position: relative;\n    cursor: pointer;\n    background: white;\n}\n\n.calendarGridDay_cell:hover {\n    background: #f8f9fa;\n}\n\n.calendarGridDay_ticket {\n    position: absolute;\n    left: 2px;\n    right: 2px;\n    background: var(--ticket-color-back);\n    border-left: 3px solid var(--ticket-color-side);\n    border-radius: 4px;\n    padding: 4px 8px;\n    cursor: pointer;\n    overflow: hidden;\n    z-index: 5;\n    min-height: 40px;\n}\n\n.calendarGridDay_ticket:hover {\n    transform: scale(1.02);\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.calendarGridDay_ticket--colorA {\n    --ticket-color-back: #e3f2fd;\n    --ticket-color-side: #2196f3;\n    --ticket-color: #1976d2;\n}\n\n.calendarGridDay_ticket--colorB {\n    --ticket-color-back: #f3e5f5;\n    --ticket-color-side: #9c27b0;\n    --ticket-color: #7b1fa2;\n}\n\n.calendarGridDay_ticket--colorC {\n    --ticket-color-back: #e8f5e8;\n    --ticket-color-side: #4caf50;\n    --ticket-color: #388e3c;\n}\n\n.calendarGridDay_ticket_content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.calendarGridDay_ticket_time {\n    font-size: 10px;\n    color: var(--ticket-color);\n    font-weight: 500;\n}\n\n.calendarGridDay_ticket_title {\n    font-size: 12px;\n    color: var(--ticket-color);\n    font-weight: 400;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
